import { render } from "./h-help.vue?vue&type=template&id=31785bd6"
import script from "./h-help.vue?vue&type=script&lang=js"
export * from "./h-help.vue?vue&type=script&lang=js"

import "./h-help.vue?vue&type=style&index=0&id=31785bd6&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__